export default __webpack_public_path__ + "static/media/script_control.04672723.svg";